import Globalize from '@sprinx/globalize';
import forDate from '../utils/forDate';
import forLocale from '../utils/forLocale';
var localeFmt = {};
/**
 * Naformatuje datum.
 *
 * @param {Date | string} [d]
 *
 * @returns {string} Retezec naformatovaneho datumu
 */

var dateFormatter = function dateFormatter(d, options) {
  return forLocale(localeFmt, {}, function (fmt) {
    return forDate(d, function (dt) {
      options = options || {
        skeleton: 'yMd'
      };
      var k = JSON.stringify(options);

      if (!fmt[k]) {
        fmt[k] = Globalize.dateFormatter(options);
      }

      return fmt[k](dt);
    });
  });
};

export default dateFormatter;